import { render } from "./DefaultImage.vue?vue&type=template&id=62c35676"
import script from "./DefaultImage.vue?vue&type=script&lang=js"
export * from "./DefaultImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__